// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuZ8uqez_kLYFL {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}
.ROYV_WATxxCqGY {
  padding-left: var(--ds-space-025, 2px);
  color: var(--ds-icon-danger, #e34935);
}
`, ""]);
// Exports
export var label = `GuZ8uqez_kLYFL`;
export var required = `ROYV_WATxxCqGY`;
export default ___CSS_LOADER_EXPORT___;
